import { makeAutoObservable } from 'mobx';
import { AdminCouponDto,  } from 'services/data-contracts';
import { CouponFilterType } from 'types/CommonTypes';
import ServiceHelper from './ServiceHelper';
import { PaginationInfo, getPaginationHeader } from 'libs/helper/paginationUtil';
export interface isValid {
  isValid: boolean;
}

class CouponFilterStore {
  coupons: AdminCouponDto[] = [];

  filteredCoupons: AdminCouponDto[] = [];

  userCoupons: AdminCouponDto[] = [];

  filteredUserCoupons: AdminCouponDto[] = [];

  paginationInfo: PaginationInfo | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  /**
   * @description 일별 예약 조회
   * @param filter
   */
  getCoupons(filter: CouponFilterType) {
    ServiceHelper.adminCouponService
      ?.getCoupons({
        page: filter.page ? filter.page - 1 : 0,
        size: filter.size ?? 40,
        searchKeyword: filter.keyword ?? '',
      })
      .then((res) => {
        this.coupons = [...res.data];
        this.filteredCoupons = [...res.data];
        this.paginationInfo = getPaginationHeader(res.headers);
      });
  }

  getUserCoupons(couponId: number, filter: CouponFilterType) {
    ServiceHelper.adminCouponService?.getUserCouponsByCoupon(couponId, {
      page: filter.page ? filter.page - 1 : 0,
        size: filter.size ?? 40,
      searchKeyword: filter.keyword ?? '',
    }).then((res) => {
      this.userCoupons = [...res.data];
      this.filteredUserCoupons = [...res.data];
      this.paginationInfo = getPaginationHeader(res.headers);
    });
  }

  unmount() {
    this.coupons = [];
  }
}

export default CouponFilterStore;
